import React, { useState } from 'react';
import ResumeEditor from './components/ResumeEditor';
import ResumePreview from './components/ResumePreview';
import Navbar from './components/Navbar';

function App() {
  const [resumeData, setResumeData] = useState({
    personalInfo: { fullName: '', email: '', phone: '', address: '', summary: '', profileImage: null },
    experience: [],
    education: [],
    skills: [],
    projects: []
  });

  const [view, setView] = useState('edit'); // toggle between 'edit' and 'preview'

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar setView={setView} />
      {view === 'edit' ? (
        <main className="container mx-auto py-10">
          <ResumeEditor resumeData={resumeData} setResumeData={setResumeData} />
          <div className="text-center mt-6">
            <button 
              onClick={() => setView('preview')}
              className="bg-blue-600 text-white px-6 py-2 rounded shadow hover:bg-blue-700"
            >
              Preview Resume
            </button>
          </div>
        </main>
      ) : (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 py-10">
          <button 
            onClick={() => setView('edit')} 
            className="mb-6 text-blue-600 hover:text-blue-800 font-medium text-lg"
          >
            ← Back to Edit
          </button>
          <ResumePreview data={resumeData} />
        </div>
      )}
    </div>
  );
}

export default App;